import {connect} from 'react-redux';
import {Poster as Component} from './Poster';
import {
  setModal,
  showModal,
  createPoster
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("posters") &&
     state.notebook.protocolSection.scene.apparatus.posters.some(
       poster => poster.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.posters[ownProps.id-1].type,
      altText: state.notebook.protocolSection.scene.apparatus.posters[ownProps.id-1].altText,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPoster: (data) => {
      dispatch(createPoster(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const Poster = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
